export default "__VITE_ASSET__9e40403d__"